const getAvailableSchedule = (schedules, timezone) => {
  try {
    const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    let now;
    if (timezone) {
      try {
        now = new Date((/* @__PURE__ */ new Date()).toLocaleString("en-US", { timeZone: timezone }));
        if (isNaN(now.getTime())) {
          throw new Error("Invalid timezone");
        }
      } catch (error) {
        console.error(`Invalid timezone: ${timezone}. Using local timezone instead.`, error);
        now = /* @__PURE__ */ new Date();
      }
    } else {
      now = /* @__PURE__ */ new Date();
    }
    const currentDayIndex = now.getDay();
    const currentHours = now.getHours();
    const currentMinutes = now.getMinutes();
    const currentTimeInMinutes = currentHours * 60 + currentMinutes;
    const currentDaySchedule = schedules.find((s) => s.weekday === weekdays[currentDayIndex]);
    if (currentDaySchedule && currentDaySchedule.startTime && currentDaySchedule.startTime !== "-") {
      const timeMatch = currentDaySchedule.startTime.match(/(\d+):(\d+)\s*([AP]M)/);
      if (timeMatch) {
        const [, hours, minutes, period] = timeMatch;
        const startHours = parseInt(hours) + (period === "PM" && parseInt(hours) !== 12 ? 12 : 0) - (period === "AM" && parseInt(hours) === 12 ? 12 : 0);
        const startTimeInMinutes = startHours * 60 + parseInt(minutes);
        if (currentTimeInMinutes < startTimeInMinutes) {
          return currentDaySchedule;
        }
      }
    }
    for (let i = 1; i <= 7; i++) {
      const nextDayIndex = (currentDayIndex + i) % 7;
      const nextDaySchedule = schedules.find((s) => s.weekday === weekdays[nextDayIndex]);
      if (nextDaySchedule && nextDaySchedule.startTime && nextDaySchedule.startTime !== "-") {
        return nextDaySchedule;
      }
    }
    return schedules[0];
  } catch (error) {
    console.error("Error getting available schedule:", error);
  }
};

export { getAvailableSchedule };
//# sourceMappingURL=src-utils-gcp-utils.js.map
